import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { paymentMethodDropdown } from "./processDropdown";
import { Autocomplete, Button, TextField } from "@mui/material";
import { useSaveBookingFormMutation } from "state/api";

const BookingForm = ({ data, setLoader }) => {
  const [saveBookingForm] = useSaveBookingFormMutation();
  const [totalAmount, setTotalAmount] = useState(0);
  const [balanceAmount, setBalanceAmount] = useState(0);

  const formik = useFormik({
    initialValues: {
      bookingTime:
        new Date().toISOString().slice(0, 11) +
        new Date().toLocaleTimeString().slice(0, 5),
      dealAmount: 0,
      bookingAmount: 0,
      transportCharges: 0,
      rtoCharges: 0,
      vasCharges: 0,
      vasRemarks: "",
      tcs: 0,
      insuranceAmount: 0,
      commissionAmount: 0,
      buyBackAmount: 0,
      paymentMode: paymentMethodDropdown[0],
    },
    onSubmit: (values) => {
      values.transactionId = data._id;
      setLoader(true);
      saveBookingForm(values)
        .unwrap()
        .then((res) => {
          alert("Booking Form Saved");
          setLoader(false);
          window.location.reload();
        })
        .catch((err) => {
          alert("Booking Form Failed");
          setLoader(false);
        });
    },
  });

  useEffect(() => {
    setTotalAmount(
      formik.getFieldProps("dealAmount").value +
        formik.getFieldProps("transportCharges").value +
        formik.getFieldProps("rtoCharges").value +
        formik.getFieldProps("vasCharges").value +
        formik.getFieldProps("tcs").value +
        formik.getFieldProps("insuranceAmount").value +
        formik.getFieldProps("commissionAmount").value -
        formik.getFieldProps("buyBackAmount").value
    );
  }, [
    formik.values.dealAmount,
    formik.values.transportCharges,
    formik.values.rtoCharges,
    formik.values.vasCharges,
    formik.values.tcs,
    formik.values.insuranceAmount,
    formik.values.commissionAmount,
    formik.values.buyBackAmount,
    formik,
  ]);

  useEffect(() => {
    setBalanceAmount(
      formik.getFieldProps("dealAmount").value +
        formik.getFieldProps("transportCharges").value +
        formik.getFieldProps("rtoCharges").value +
        formik.getFieldProps("vasCharges").value +
        formik.getFieldProps("tcs").value +
        formik.getFieldProps("insuranceAmount").value +
        formik.getFieldProps("commissionAmount").value -
        formik.getFieldProps("buyBackAmount").value -
        formik.getFieldProps("bookingAmount").value
    );
  }, [
    formik.values.dealAmount,
    formik.values.transportCharges,
    formik.values.rtoCharges,
    formik.values.vasCharges,
    formik.values.tcs,
    formik.values.insuranceAmount,
    formik.values.commissionAmount,
    formik.values.buyBackAmount,
    formik.values.bookingAmount,
    formik,
  ]);

  return (
    <>
      <div className="my-2 text-lg font-bold text-gray-700">Booking Form</div>

      <form onSubmit={formik.handleSubmit}>
        <div className="mt-4 grid grid-cols-2 gap-4">
          <TextField
            id="bookingTime"
            name="bookingTime"
            label="Booking Time"
            type="datetime-local"
            value={formik.values.bookingTime}
            onChange={formik.handleChange}
            
            fullWidth
          />
          <TextField
            id="dealAmount"
            name="dealAmount"
            label="Deal Amount"
            type="number"
            value={formik.values.dealAmount}
            onChange={formik.handleChange}
            fullWidth
          />
          <TextField
            id="bookingAmount"
            name="bookingAmount"
            label="Booking Amount"
            type="number"
            value={formik.values.bookingAmount}
            onChange={formik.handleChange}
            fullWidth
          />
          <TextField
            id="transportCharges"
            name="transportCharges"
            label="Transport Charges"
            type="number"
            value={formik.values.transportCharges}
            onChange={formik.handleChange}
            fullWidth
          />
          <TextField
            id="rtoCharges"
            name="rtoCharges"
            label="RTO Charges"
            type="number"
            value={formik.values.rtoCharges}
            onChange={formik.handleChange}
            fullWidth
          />
          <TextField
            id="vasCharges"
            name="vasCharges"
            label="VAS Charges"
            type="number"
            value={formik.values.vasCharges}
            onChange={formik.handleChange}
            fullWidth
          />
          <TextField
            id="vasRemarks"
            name="vasRemarks"
            label="VAS Remarks"
            type="text"
            value={formik.values.vasRemarks}
            onChange={formik.handleChange}
            fullWidth
          />
          <TextField
            id="tcs"
            name="tcs"
            label="TCS"
            type="number"
            value={formik.values.tcs}
            onChange={formik.handleChange}
            fullWidth
          />
          <TextField
            id="insuranceAmount"
            name="insuranceAmount"
            label="Insurance Amount"
            type="number"
            value={formik.values.insuranceAmount}
            onChange={formik.handleChange}
            fullWidth
          />
          <TextField
            id="commissionAmount"
            name="commissionAmount"
            label="Commission Amount"
            type="number"
            value={formik.values.commissionAmount}
            onChange={formik.handleChange}
            fullWidth
          />
          <TextField
            id="buyBackAmount"
            name="buyBackAmount"
            label="Buy Back Amount"
            type="number"
            value={formik.values.buyBackAmount}
            onChange={formik.handleChange}
            fullWidth
          />
          <Autocomplete
            id="paymentMode"
            name="paymentMode"
            options={paymentMethodDropdown}
            getOptionLabel={(option) => option}
            value={formik.values.paymentMode}
            onChange={(event, newValue) => {
              formik.setFieldValue("paymentMode", newValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Payment Mode" />
            )}
            fullWidth
          />
          <TextField
            id="totalAmount"
            name="totalAmount"
            label="Total Amount"
            type="number"
            value={totalAmount}
            fullWidth
            disabled
          />
          <TextField
            id="balanceAmount"
            name="balanceAmount"
            label="Balance Amount"
            type="number"
            value={balanceAmount}
            fullWidth
            disabled
          />

          <Button
            type="submit"
            className="my-2 bg-slate-600 hover:bg-slate-700 text-white w-24"
          >
            Submit
          </Button>
        </div>
      </form>
    </>
  );
};

export default BookingForm;
